import { SovUploadSheet } from "./sov-upload";

/** The 4 backend wizard steps (see docs/AI/MAIA-Wizard-Step-Cleanup-And-Resume-Plan.md §1.1). */
export type MaiaWizardStep = 1 | 2 | 3 | 4;

/** Known `currentScreen` keys, grouped by the step they belong to. Backend accepts any string. */
export const MaiaScreen = {
    UPLOAD_FILE: "upload_file",
    REVIEW_GEOCODING: "review_geocoding",
    GEOCODING_IN_PROGRESS: "geocoding_in_progress",
    GEOCODING_COMPLETE: "geocoding_complete",
    GEOCODING_NEEDS_ATTENTION: "geocoding_needs_attention",
    GEOCODING_FAILED: "geocoding_failed",
    PORTFOLIO_ENRICHMENT: "portfolio_enrichment",
    PORTFOLIO_ENHANCING: "portfolio_enhancing",
    PORTFOLIO_READY: "portfolio_ready",
    ANALYZE_REPORT: "analyze_report",
    PREPARE_SOV: "prepare_sov",
    GROUP_LOCATIONS: "group_locations",
    IMPORT_SUCCESS: "import_success",
} as const;

export type MaiaScreenKey = (typeof MaiaScreen)[keyof typeof MaiaScreen];

/** Per-step resume state, as returned inside GET /sov/{jobId}. */
export interface MaiaStepStatus {
    step: MaiaWizardStep;
    status: "NOT_STARTED" | "IN_PROGRESS" | "COMPLETE";
    activeScreen: string | null;
    lastScreen: string | null;
}

/** Body of PUT /sov/{jobId}/wizard-progress — completedSteps is additive, not full history. */
export interface MaiaWizardProgressUpdate {
    currentScreen: string;
    completedSteps: MaiaWizardStep[];
}

/** One row of GET /sov/dataset/{datasetId}/active-jobs: the caller's own open job on the dataset. */
export interface SovActiveJobSummary {
    jobId: number;
    datasetId: string;
    fileName: string | null;
    status: string;
    currentStep: MaiaWizardStep | null;
    currentScreen: string | null;
    updatedAt: string | number | null;
}

/** The wizard-progress fields GET /sov/{jobId} carries alongside the rest of the job payload. */
export interface SovJobState {
    id: number;
    accountId: number | null;
    datasetId: string | null;
    fileName?: string;
    /** Bytes — see MaiaUploadService.getJobState / formatFileSize in maia-file-size.util.ts. */
    fileSize?: number;
    totalRows?: number;
    sheets?: SovUploadSheet[];
    currentScreen: string | null;
    completedSteps: MaiaWizardStep[];
    currentStep: MaiaWizardStep;
    stepStatuses: MaiaStepStatus[];
}
